var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 16,
    viewBox: "0 0 37 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_709_993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1355 5.83634C19.1144 7.5079 20.6188 8.44077 21.752 8.99535C22.9164 9.56444 23.3075 9.92933 23.303 10.4382C23.2942 11.217 22.3742 11.5607 21.5132 11.5741C20.011 11.5975 19.1377 11.1668 18.4433 10.841L17.9023 13.384C18.5989 13.7065 19.8888 13.9877 21.2265 14C24.3663 14 26.4206 12.4434 26.4317 10.0298C26.444 6.96671 22.2131 6.7971 22.242 5.42793C22.252 5.01283 22.6464 4.56984 23.5108 4.45713C23.9386 4.40022 25.1196 4.3567 26.4584 4.97601L26.9839 2.51553C26.264 2.25219 25.3385 2 24.1863 2C21.231 2 19.1522 3.57783 19.1355 5.83634ZM32.0336 2.21201C31.4603 2.21201 30.977 2.54789 30.7615 3.06342L26.2762 13.8192H29.4138L30.0382 12.0863H33.8724L34.2346 13.8192H37L34.5868 2.21201H32.0336ZM32.4725 5.34759L33.378 9.70616H30.8981L32.4725 5.34759ZM15.3313 2.21201L12.8581 13.8192H15.8479L18.32 2.21201H15.3313ZM10.9082 2.21201L7.7962 10.1123L6.53739 3.39483C6.38962 2.64497 5.80632 2.21201 5.15859 2.21201H0.071113L0 2.549C1.04438 2.77664 2.23098 3.14376 2.94982 3.53655C3.3898 3.77646 3.51534 3.98624 3.65978 4.55644L6.04409 13.8192H9.20389L14.048 2.21201H10.9082Z",
    fill: "#1434CB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_709_993"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.f50cdaf43c9e5a51b5abc872db1f9972.svg";
export { ForwardRef as ReactComponent };